import {Text, Box, Flex} from '@chakra-ui/react';
import {
  RenderRule,
  isHeading,
  isParagraph,
} from 'datocms-structured-text-utils';
import {StructuredText, ResponsiveImageType} from 'react-datocms';
import {DatoCmsImage} from '../datocms/image';

interface ImageWithTextSectionProps {
  background?: string;
  imageSide: string;
  imagePositionMobile: string;
  image: ResponsiveImageType;
  text: any;
  textStyle: string;
  centerTextMobile: boolean;
}

export const ImageWithTextSection: React.FC<ImageWithTextSectionProps> = ({
  text,
  textStyle,
  imageSide,
  imagePositionMobile,
  image,
  background,
  centerTextMobile,
}) => {
  const headingRenderRule: RenderRule<any, any, any> = {
    appliable: isHeading,
    apply: ({children, key}) => {
      return children ? (
        <Text
          key={key}
          textStyle={
            textStyle === 'showpiece_1c'
              ? {base: 'h6_1c', lg: 'h3_1c'}
              : {base: 'h5', lg: 'h4'}
          }
          pb={4}
        >
          {children}
        </Text>
      ) : null;
    },
  };

  const paragraphRenderRule: RenderRule<any, any, any> = {
    appliable: isParagraph,
    apply: ({children, key}) =>
      children ? (
        <Text
          key={key}
          textStyle={
            textStyle === 'showpiece_1c'
              ? {base: 'body3_1c', lg: 'body2_1c'}
              : {base: 'body2', lg: 'body1'}
          }
        >
          {children}
        </Text>
      ) : null,
  };

  const renderRules = [headingRenderRule, paragraphRenderRule];
  return (
    <Box bg={background}>
      <Box
        maxW={{base: '550px', lg: '1000px'}}
        m="0 auto"
        pb={{base: '0px', md: '24px'}}
      >
        <Flex flexWrap="wrap" justify="center" align="center">
          <Flex
            flexDir={{
              base: imagePositionMobile === 'top' ? 'column' : 'column-reverse',
              lg: imageSide === 'right' ? 'row-reverse' : 'row',
            }}
            alignItems={{lg: 'center'}}
            py="40px"
            w="100%"
          >
            <Flex
              flex={1}
              flexDir="column"
              mb={{base: imagePositionMobile === 'top' ? '48px' : '0px', lg: 0}}
              mt={{base: imagePositionMobile !== 'top' ? '48px' : '0px', lg: 0}}
              justifyContent="center"
              alignItems="center"
            >
              <Box maxW={{base: '550px', lg: '450px'}}>
                {image && <DatoCmsImage responsiveImage={image} />}
              </Box>
            </Flex>
            {text && (
              <Flex
                pr={{lg: imageSide === 'right' ? 100 : 0}}
                pl={{lg: imageSide === 'right' ? 0 : 100}}
                flex={1}
                flexDir="column"
              >
                <Box
                  textAlign={{
                    base: centerTextMobile ? 'center' : 'start',
                    lg: 'start',
                  }}
                  mx={{base: 4, md: 0}}
                >
                  <StructuredText data={text} customRules={renderRules} />
                </Box>
              </Flex>
            )}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
